<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0.9499999284744263C15,0.9499999284744263,1,0.9499999284744263,1,0.9499999284744263C0.45,0.9499999284744263,0,1.3999999284744262,0,1.9499999284744263C0,1.9499999284744263,0,13.949999928474426,0,13.949999928474426C0,14.499999928474427,0.45,14.949999928474426,1,14.949999928474426C1,14.949999928474426,15,14.949999928474426,15,14.949999928474426C15.55,14.949999928474426,16,14.499999928474427,16,13.949999928474426C16,13.949999928474426,16,1.9499999284744263,16,1.9499999284744263C16,1.3999999284744262,15.55,0.9499999284744263,15,0.9499999284744263C15,0.9499999284744263,15,0.9499999284744263,15,0.9499999284744263ZM6,12.949999928474426C6,12.949999928474426,2,12.949999928474426,2,12.949999928474426C2,12.949999928474426,2,6.949999928474426,2,6.949999928474426C2,6.949999928474426,6,6.949999928474426,6,6.949999928474426C6,6.949999928474426,6,12.949999928474426,6,12.949999928474426C6,12.949999928474426,6,12.949999928474426,6,12.949999928474426ZM14,12.949999928474426C14,12.949999928474426,7,12.949999928474426,7,12.949999928474426C7,12.949999928474426,7,6.949999928474426,7,6.949999928474426C7,6.949999928474426,14,6.949999928474426,14,6.949999928474426C14,6.949999928474426,14,12.949999928474426,14,12.949999928474426C14,12.949999928474426,14,12.949999928474426,14,12.949999928474426ZM14,5.949999928474426C14,5.949999928474426,2,5.949999928474426,2,5.949999928474426C2,5.949999928474426,2,2.9499999284744263,2,2.9499999284744263C2,2.9499999284744263,14,2.9499999284744263,14,2.9499999284744263C14,2.9499999284744263,14,5.949999928474426,14,5.949999928474426C14,5.949999928474426,14,5.949999928474426,14,5.949999928474426Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'PageLayout',
} as DefineComponent
</script>
